// Customise Freeform's Stripe Payment Element to match ARTRAGE brand.
// Freeform 5 fires `freeform-stripe-appearance` on each [data-freeform-stripe-card]
// container before mounting the Stripe element. The event's `elementOptions` and
// `paymentOptions` properties are read back after dispatch, so mutating them here
// flows through to Stripe Elements' Appearance API.
// Attach immediately (not inside load) — the event can fire as soon as the
// payment intent request resolves, which may be before window 'load'.
document.addEventListener('freeform-stripe-appearance', (event) => {
    const yellow = '#DDFF00';
    const white = '#ffffff';
    const panelBg = '#212121';      // artrage-black-2 (same as the donation panel)
    const inputBg = '#2c2c2c';      // slightly lifted from panel for input affordance
    const tabBg = '#2c2c2c';
    const subtleBorder = 'rgba(255,255,255,0.15)';
    const danger = '#ff6b6b';

    event.elementOptions = event.elementOptions || {};

    // Stripe Elements runs in a cross-origin iframe and cannot inherit the
    // page's Typekit-served nunito-sans (Typekit gates by referrer and
    // doesn't serve to Stripe's iframe). Google Fonts hosts a visually
    // identical "Nunito Sans" with permissive CORS so the iframe can load it.
    event.elementOptions.fonts = [
        ...(event.elementOptions.fonts || []),
        { cssSrc: 'https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;500;600;700&display=swap' },
    ];

    event.elementOptions.appearance = {
        ...(event.elementOptions.appearance || {}),
        theme: 'night',
        labels: 'above',
        variables: {
            ...(event.elementOptions.appearance?.variables || {}),
            colorPrimary: yellow,
            colorBackground: inputBg,
            colorText: white,
            colorDanger: danger,
            colorTextSecondary: 'rgba(255,255,255,0.85)',
            colorTextPlaceholder: 'rgba(255,255,255,0.45)',
            colorIcon: 'rgba(255,255,255,0.85)',
            colorIconHover: white,
            borderRadius: '4px',
            spacingUnit: '4px',
            fontFamily: '"Nunito Sans", "nunito-sans", sans-serif',
            fontSizeBase: '16px',
            fontWeightNormal: '400',
            fontWeightMedium: '500',
        },
        rules: {
            ...(event.elementOptions.appearance?.rules || {}),
            '.Tab': {
                backgroundColor: tabBg,
                border: `1px solid ${subtleBorder}`,
                borderRadius: '4px',
                boxShadow: 'none',
                color: 'rgba(255,255,255,0.85)',
                transition: 'all 150ms ease',
                padding: '12px 14px',
            },
            '.Tab:hover': {
                backgroundColor: '#363636',
                borderColor: 'rgba(255,255,255,0.4)',
                color: white,
            },
            '.Tab--selected': {
                backgroundColor: yellow,
                borderColor: yellow,
                color: '#070707',
                boxShadow: 'none',
            },
            '.TabIcon': {
                fill: 'rgba(255,255,255,0.85)',
            },
            '.TabIcon--selected': {
                fill: '#070707',
            },
            '.TabLabel--selected': {
                color: '#070707',
            },
            '.Input': {
                backgroundColor: inputBg,
                border: `1px solid ${subtleBorder}`,
                borderRadius: '4px',
                boxShadow: 'none',
                color: white,
                // Match the 48px min-height of the outer Freeform inputs.
                // Stripe enforces a minimum padding rather than a height
                // property, so use vertical padding to push the field up.
                padding: '13px 12px',
                fontSize: '16px',
                lineHeight: '20px',
            },
            // Note: .Input focus styling is driven by the `colorPrimary`
            // variable (yellow). Stripe rejects `:focus`/`--focus` selectors
            // on .Input directly, so we let the variable do the work.
            '.Input--invalid': {
                borderColor: danger,
                boxShadow: 'none',
            },
            '.Label': {
                color: white,
                fontWeight: '400',
                // Match the ~10px label-to-input gap of the outer ARTRAGE
                // form fields (mb-2.5 on the .freeform-label).
                marginBottom: '10px',
            },
            '.Block': {
                backgroundColor: inputBg,
                border: `1px solid ${subtleBorder}`,
                borderRadius: '4px',
            },
            '.RedirectText, .Link, .Action': {
                color: yellow,
            },
            '.Error': {
                color: danger,
            },
        },
    };
});

window.addEventListener('load', () => {
    const stripeFormPanel = document.querySelectorAll('.stripe-donation-header-panel');

    if (stripeFormPanel.length) {
        document.addEventListener('click', (event) => {
            const target = event.target;

            // Handle showing of forms in multipage form panels
            if (target.matches('[data-toggle-form-index]') || target.parentElement?.matches('[data-toggle-form-index]')) {
                const showFormContainer = target.closest('[data-show-form-index]');
                const toggleFormIndex = target.dataset.toggleFormIndex;

                if (showFormContainer && toggleFormIndex) {
                    showFormContainer.dataset.showFormIndex = toggleFormIndex;
                }
            }
        });
    }
});
